// extracted by mini-css-extract-plugin
export default {"floatingPanel":"FloatingPanel-module__floatingPanel___QdQhh","sticky":"FloatingPanel-module__sticky___xAodk"};